// extracted by mini-css-extract-plugin
module.exports = {"menu":"MenuMobile_menu__3cXKz"};